import React from 'react';
import { ImageOff } from 'lucide-react';
import { useImageLoader } from '../hooks/useImageLoader';

interface ImageWithFallbackProps {
  src: string;
  alt: string;
  className?: string;
  fallbackText?: string;
  showPlaceholder?: boolean;
}

export function ImageWithFallback({
  src,
  alt,
  className = '',
  fallbackText,
  showPlaceholder = true
}: ImageWithFallbackProps) {
  const { isLoading, error, imageUrl } = useImageLoader(src, fallbackText);

  if (isLoading) {
    return (
      <div className={`flex items-center justify-center bg-gray-100 ${className}`}>
        <div className="animate-spin rounded-full h-8 w-8 border-2 border-blue-600 border-t-transparent"></div>
      </div>
    );
  }

  if (error && showPlaceholder) {
    return (
      <div className={`flex flex-col items-center justify-center bg-gray-100 ${className}`}>
        <ImageOff className="w-12 h-12 text-gray-400 mb-2" />
        <span className="text-sm text-gray-500">{fallbackText || 'Image Not Available'}</span>
      </div>
    );
  }

  return (
    <img
      src={imageUrl}
      alt={alt}
      className={className}
      loading="lazy"
    />
  );
}